import { EWebimActions } from '../../constants/actionTypes';
import { TReduxActions } from '../../types/redux';
import { IWebimState } from '../../types/redux/webim';

export const defaultState = {
  isVisibleChat: false,
  isVisibleInformer: true,
};

export function webimReducer(state: IWebimState = defaultState, action: TReduxActions) {
  switch (action.type) {
    case EWebimActions.setVisibleChat:
      return {
        ...state,
        isVisibleChat: action.payload,
      };

    case EWebimActions.toggleVisibleInformer:
      return {
        ...state,
        isVisibleInformer: action.payload,
      };

    default:
      return state;
  }
}
